// extracted by mini-css-extract-plugin
export var button = "post-module--button--LvcgH";
export var container = "post-module--container--2bHBd";
export var container__content = "post-module--container__content--2UyCK";
export var container__content__tags = "post-module--container__content__tags--3p9wc";